export default __webpack_public_path__ + "static/media/industry2.07a0808c.jpg";